import React from 'react';
import { X } from 'lucide-react';
import OriginSourceOverview from './OriginSourceOverview';

const HoverTooltip = ({
  overviewData,
  splitView,
  defaultFilters,
  hoveredBarIndex,
  chartLabels,
  originalDateLabels,
  position,
  hiddenDatasets,
  setHiddenDatasets,
  onClose,
  isMobileOrTablet = false,
  setClickedBarInfo,
}) => {
  const shouldShow = isMobileOrTablet
    ? hoveredBarIndex !== null && hoveredBarIndex !== undefined
    : position && hoveredBarIndex !== null && hoveredBarIndex !== undefined;

  if (!shouldShow) {
    return null;
  }

  const clickedBarInfo =
    hoveredBarIndex !== null && chartLabels?.[hoveredBarIndex]
      ? {
          date:
            originalDateLabels && originalDateLabels[hoveredBarIndex]
              ? originalDateLabels[hoveredBarIndex]
              : chartLabels[hoveredBarIndex],
        }
      : null;

  return (
    <>
      {isMobileOrTablet && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-999"
          onClick={onClose}
        />
      )}
      <div
        className={`fixed shadow-lg z-999 w-500 rounded-lg bg-white ${
          isMobileOrTablet ? 'pointer-events-auto' : 'pointer-events-none'
        }`}
        style={
          isMobileOrTablet
            ? {
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                maxWidth: '500px',
                maxHeight: '90vh',
                overflowY: 'auto',
              }
            : {
                left: `${position.x}px`,
                top: `calc(${position.y}px - 130px)`,
              }
        }>
        {isMobileOrTablet && onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 bg-transparent border-none right-3 p-1.5 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors z-10"
            aria-label="Close">
            <X size={20} className="text-gray-600" />
          </button>
        )}
        <OriginSourceOverview
          overviewData={overviewData}
          splitView={splitView}
          defaultFilters={defaultFilters}
          selectedDayIndex={hoveredBarIndex}
          chartLabels={chartLabels}
          clickedBarInfo={clickedBarInfo}
          originalDateLabels={originalDateLabels}
          hiddenDatasets={hiddenDatasets}
          setHiddenDatasets={setHiddenDatasets}
          isTooltip={true}
          isMobileOrTablet={isMobileOrTablet}
          setClickedBarInfo={setClickedBarInfo}
          onClose={onClose}
        />
      </div>
    </>
  );
};

export default HoverTooltip;
